module.exports = __webpack_public_path__ + "static/img/z.shield-2.afcbd83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/z.shield-2.svg
// module id = m0SP
// module chunks = 1